import Axios from "axios";
import { setupCache } from "axios-cache-interceptor";

const api = setupCache(
  Axios.create({ baseURL: process.env.REACT_APP_API_URL }),
  { ttl: 15 * 60 * 1000 }
);

api.interceptors.request.use(function (config) {
  config.headers.Authorization = process.env.REACT_APP_CDEV_KEY;
  return config;
});

api.interceptors.request.use(
  function (config) {
    window.$loading += 1;
    document.getElementById("loading").setAttribute("rel", window.$loading);
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  function (config) {
    window.$loading -= 1;
    document.getElementById("loading").setAttribute("rel", window.$loading);
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default api;
